import { CoverageByTopIndustriesRO, WeeklySnapshotDTO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";

export const getCoverageByTopIndustries = async (
  id: number,
  filters: WeeklySnapshotDTO
): Promise<CoverageByTopIndustriesRO> => {
  const { data } = await apiService.get<CoverageByTopIndustriesRO>(
    Endpoints.Campaigns.Get.WeeklySnapshot.CoverageByTopIndustries(id),
    {
      params: {
        yearTo: filters.yearTo,
        weekTo: filters.weekTo,
      },
    }
  );

  return data;
};
